import { Modal } from "~/ui/common";

interface ToggleConfirmDialogProps {
  show: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isLoading: boolean;
}

export const ToggleConfirmDialog = ({
  show,
  onConfirm,
  onClose,
  isLoading,
}: ToggleConfirmDialogProps) => {
  return (
    <Modal
      show={show}
      title="Activate banner"
      onClose={onClose}
      handleConfirm={onConfirm}
      confirmLabel="Activate"
      isLoading={isLoading}
    >
      <p className="text-lg text-neutral-600">
        This will deactivate the currently active banner. Continue?
      </p>
    </Modal>
  );
};
